import React from "react";

import { OverflowDisplayTooltip } from "../../Tooltip/OverflowDisplayTooltip";

export interface MetadataItem {
  text: string;
  icon?: React.ComponentType<{ className?: string }>;
  tooltip?: string;
  className?: string;
  maxWidth?: number;
}

interface CardMetadataProps {
  metadata: MetadataItem[];
  emptyText?: string;
}

export const CardMetadata = ({ metadata, emptyText }: CardMetadataProps) => {
  if (metadata.length === 0) {
    if (!emptyText) {
      return null;
    }

    return (
      <div className="flex min-w-0 max-w-full items-center gap-1 overflow-hidden text-sm text-gray-400 transition-colors duration-200 ease-in-out">
        <span className="text-sm text-gray-400 transition-colors duration-200 ease-in-out">
          {emptyText}
        </span>
      </div>
    );
  }

  return (
    <div className="flex min-w-0 max-w-full items-center gap-1 overflow-hidden text-sm text-gray-400 transition-colors duration-200 ease-in-out">
      {metadata.map(({ text, icon: Icon, tooltip, className, maxWidth }, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`${text}-${index}`}
          className="flex min-w-0 shrink items-center gap-x-1.5 transition-colors duration-200 ease-in-out"
        >
          <div
            className={`flex min-w-0 items-center gap-1 transition-colors duration-200 ease-in-out ${
              className || ""
            }`}
          >
            {Icon && (
              <span className="flex max-h-3.5 min-h-3.5 min-w-3.5 max-w-3.5 flex-shrink-0">
                <Icon className="h-full w-full" />
              </span>
            )}
            <OverflowDisplayTooltip
              side="bottom"
              ignoreOverflow={!!tooltip}
              styles={
                maxWidth
                  ? {
                      maxWidth: `${maxWidth}px`,
                    }
                  : undefined
              }
              content={tooltip || text}
            >
              <span className="min-w-0 truncate transition-colors duration-200 ease-in-out">
                {text}
              </span>
            </OverflowDisplayTooltip>
          </div>
          {index < metadata.length - 1 && (
            <span className="flex-shrink-0 transition-colors duration-200 ease-in-out">•</span>
          )}
        </div>
      ))}
    </div>
  );
};
